/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureFlag } from '../models/FeatureFlag';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeatureFlagsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns FeatureFlag
     * @throws ApiError
     */
    public featureFlagsList(): CancelablePromise<Array<FeatureFlag>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/feature-flags/',
        });
    }

}
